import { styled } from '@mui/material/styles';

import { tokens } from '../../design';

/**
 * Sidebar root — dark gradient base + radial dot-grid texture (LOCK 11,
 * pixel-match to `design/mockups/admin/layout.html` `.sb`).
 *
 * Width 220px (layout.html inline override; tokens.css `--sidebar-width`
 * of 240 is shadowed by the live mockup).
 */
export const SidebarRoot = styled('aside')({
  width: tokens.layout.sidebarWidth,
  flexShrink: 0,
  background: `linear-gradient(180deg, ${tokens.surface.sidebar} 0%, #060c08 100%)`,
  color: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  // Dot-grid texture overlay — pseudo-element so children don't inherit.
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundImage: 'radial-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px)',
    backgroundSize: '18px 18px',
    opacity: 0.45,
    pointerEvents: 'none',
  },
});

export const SidebarTop = styled('div')({
  position: 'relative',
  zIndex: 1,
  padding: '18px 18px',
  display: 'flex',
  alignItems: 'center',
  gap: 11,
  borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
});

/**
 * Brand mark slot — holds the i-with-lens glyph, always brand green (AUT-511,
 * D-11). The glyph is shown bare, without the old green tile: green on green
 * would vanish, and the mark is «only the letter i» in every interface (D-7).
 */
export const SidebarBrandMark = styled('div')({
  width: 32,
  height: 32,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

/** The glyph image itself: fills the slot's height, width follows (aspect 204/634). */
export const SidebarGlyph = styled('img')({
  height: '100%',
  width: 'auto',
  display: 'block',
});

export const SidebarBrandName = styled('div')({
  fontSize: 14,
  fontWeight: 700,
  '& small': {
    display: 'block',
    fontSize: 9,
    opacity: 0.5,
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    marginTop: 2,
  },
});

export const SidebarSectionHeader = styled('div')({
  position: 'relative',
  zIndex: 1,
  fontSize: 10,
  fontWeight: 600,
  color: 'rgba(255, 255, 255, 0.32)',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  padding: '16px 18px 6px',
});

export const SidebarFooter = styled('div')({
  position: 'relative',
  zIndex: 1,
  marginTop: 'auto',
  padding: '14px 18px',
  borderTop: '1px solid rgba(255, 255, 255, 0.06)',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});

/** Footer brand slot — same bare green glyph as the top, smaller. */
export const SidebarFooterAvatar = styled('div')({
  width: 26,
  height: 26,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
